export default "__VITE_ASSET__dc2273d3__"